









































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import UpdateGeneralPayeeSettingsRequest from '@/models/Products/ProductSettings/DefaultSettings/GeneralPayee/UpdateGeneralPayeeSettingsRequest';
import FieldLabel from '@/components/Shared/FieldLabel.vue'

@Component({ name: 'AccountGeneralPayeeSettingsEditDialog', components: { FieldLabel } })
export default class extends SaascadaVueDialog {

    request: UpdateGeneralPayeeSettingsRequest = new UpdateGeneralPayeeSettingsRequest(null, null);

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdateGeneralPayeeSettingsRequest(DepositAccountSettingsModule.settings.generalPayeeSettings, new Date());
        }
    }

    get settings() {
        return DepositAccountSettingsModule.settings.generalPayeeSettings;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            this.request.maximumNumberOfPayees = +this.request.maximumNumberOfPayees;

            //This needs setting to undefined currently as it is getting stored in the JSON.
            //Plan was to send this and backend ignores it until we get concurrency checking in
            this.request.updatedAt = undefined;

            await DepositAccountSettingsModule.editGeneralPayeeSettings(this.request);
        }
    }

}
